import { COLORS } from '@constants/colors';

export const useStyles = () => ({
  container: {
    position: 'fixed',
    bottom: 80,
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: 'rgba(180, 50, 70, 0.95)',
    borderRadius: '8px',
    padding: '8px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    zIndex: 1300,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
  },
  text: {
    color: COLORS.WHITE,
    fontSize: '14px',
    fontWeight: 500,
  },
  divider: {
    color: COLORS.WHITE,
    fontSize: '14px',
  },
  exitLink: {
    color: COLORS.WHITE,
    fontSize: '14px',
    fontWeight: 500,
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': {
      color: '#ffcccc',
    },
  },
});
